import type { ReportCell, ReportColumnFormat, ReportTableData } from "../types/reports";

function escapeCsv(value: string): string {
  return /[",\r\n]/.test(value) ? `"${value.replace(/"/g, '""')}"` : value;
}

function csvCell(format: ReportColumnFormat, cell: ReportCell | undefined): string {
  if (cell === undefined || cell === "not_applicable") return "";
  if (cell === "unavailable") return "n/a";
  if (format === "rate") return (cell * 100).toFixed(2);
  return format === "usd" ? cell.toFixed(2) : String(cell);
}

export function reportTableToCsv(table: ReportTableData): string {
  const header = [table.rowLabel, ...table.columns.map((c) => (c.format === "rate" ? `${c.label} (%)` : c.label))];
  const rows = table.rows.map((row) => [row.label, ...table.columns.map((c) => csvCell(c.format, row.cells[c.key]))]);
  // The BOM tells Excel the file is UTF-8.
  return "\uFEFF" + [header, ...rows].map((line) => line.map(escapeCsv).join(",") + "\r\n").join("");
}

export function downloadCsv(filename: string, csv: string): void {
  const url = URL.createObjectURL(new Blob([csv], { type: "text/csv;charset=utf-8" }));
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}
